/* v05_a24-dawn-refactor/assets/a24-header-layout.js */
/* Sticky header and responsive top-bar visibility. */
(function () {
  'use strict';

  var mobileMediaQuery = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
  var pauseState = null;
  var scrollState = null;

  function isMobileViewport() {
    return mobileMediaQuery ? mobileMediaQuery.matches : window.innerWidth < 990;
  }

  function getHeaderSection() {
    return document.getElementById('shopify-section-header');
  }

  function getTopBar() {
    var headerSection = getHeaderSection();
    return headerSection ? headerSection.querySelector('[data-a24-top-bar]') : null;
  }

  function readTopBarConfig(topBar) {
    var mobile = isMobileViewport();
    var prefix = mobile ? 'mobile' : 'desktop';
    var mode = topBar.dataset.topBarDeviceMode || 'sync';
    var enabledFromClass = mobile
      ? topBar.classList.contains('top-bar--mobile-enabled')
      : topBar.classList.contains('top-bar--desktop-enabled');

    var enabled = true;
    var scrollBehavior = 'hide_down';
    var revealBehavior = 'top_only';

    if (mode === 'separate') {
      if (mobile) {
        enabled = topBar.dataset.separateMobileEnabled !== 'false';
        scrollBehavior = topBar.dataset.separateMobileScrollBehavior || topBar.dataset.mobileScrollBehavior || 'hide_down';
        revealBehavior = topBar.dataset.separateMobileRevealBehavior || topBar.dataset.mobileRevealBehavior || 'top_only';
      } else {
        enabled = topBar.dataset.separateDesktopEnabled !== 'false';
        scrollBehavior = topBar.dataset.separateDesktopScrollBehavior || topBar.dataset.desktopScrollBehavior || 'hide_down';
        revealBehavior = topBar.dataset.separateDesktopRevealBehavior || topBar.dataset.desktopRevealBehavior || 'top_only';
      }
    } else {
      enabled = topBar.dataset.syncEnabled !== 'false' && topBar.dataset[prefix + 'Enabled'] !== 'false';
      scrollBehavior = topBar.dataset.syncScrollBehavior || topBar.dataset[prefix + 'ScrollBehavior'] || 'hide_down';
      revealBehavior = topBar.dataset.syncRevealBehavior || topBar.dataset[prefix + 'RevealBehavior'] || 'top_only';
    }

    enabled = enabled && enabledFromClass;

    return {
      enabled: enabled,
      scrollBehavior: scrollBehavior,
      revealBehavior: revealBehavior
    };
  }

  function initTopBarInteractionPause() {
    var topBar = getTopBar();

    if (pauseState && pauseState.topBar) {
      pauseState.topBar.removeEventListener('pointerenter', pauseState.pause);
      pauseState.topBar.removeEventListener('pointerleave', pauseState.resume);
      pauseState.topBar.removeEventListener('focusin', pauseState.pause);
      pauseState.topBar.removeEventListener('focusout', pauseState.onFocusOut);
      pauseState = null;
    }

    if (!topBar) return;

    var pause = function () {
      topBar.classList.add('top-bar--paused');
    };
    var resume = function () {
      topBar.classList.remove('top-bar--paused');
    };

    var onFocusOut = function () {
      window.setTimeout(function () {
        if (!topBar.contains(document.activeElement)) {
          resume();
        }
      }, 0);
    };

    topBar.addEventListener('pointerenter', pause);
    topBar.addEventListener('pointerleave', resume);
    topBar.addEventListener('focusin', pause);
    topBar.addEventListener('focusout', onFocusOut);

    pauseState = {
      topBar: topBar,
      pause: pause,
      resume: resume,
      onFocusOut: onFocusOut
    };
  }

  function initTopBarScrollBehavior() {
    if (scrollState) {
      window.removeEventListener('scroll', scrollState.onScroll);
      if (mobileMediaQuery && scrollState.onMediaChange && typeof mobileMediaQuery.removeEventListener === 'function') {
        mobileMediaQuery.removeEventListener('change', scrollState.onMediaChange);
      }
      scrollState = null;
    }

    var topBar = getTopBar();
    if (!topBar) return;

    var body = document.body;
    var ticking = false;
    var lastY = window.scrollY || window.pageYOffset || 0;
    var revealTopOffset = 8;
    var hideTopOffset = 44;
    var mobileRevealTopOffset = 18;
    var mobileHideTopOffset = 36;
    var scrollThreshold = 6;
    var stateLockUntil = 0;
    var stateLockMs = 220;
    var topVisibilityLatch = false;

    function currentScrollY() {
      return window.scrollY || window.pageYOffset || 0;
    }

    function setTopBarHidden(nextHidden) {
      var currentHidden = body.classList.contains('a24-topbar-hidden');
      if (currentHidden === nextHidden) return false;

      body.classList.toggle('a24-topbar-hidden', nextHidden);
      stateLockUntil = performance.now() + stateLockMs;
      return true;
    }

    function update() {
      var currentY = currentScrollY();

      topBar = getTopBar();
      if (!topBar) {
        lastY = currentY;
        ticking = false;
        return;
      }

      var config = readTopBarConfig(topBar);
      var currentHidden = body.classList.contains('a24-topbar-hidden');
      var nextHidden = currentHidden;
      var mobile = isMobileViewport();
      var effectiveRevealTopOffset = mobile ? mobileRevealTopOffset : revealTopOffset;
      var effectiveHideTopOffset = mobile ? mobileHideTopOffset : hideTopOffset;
      var topSafeOffset = mobile ? Math.max(effectiveHideTopOffset, 56) : effectiveRevealTopOffset;
      var topLatchReleaseOffset = mobile ? topSafeOffset + 32 : topSafeOffset;

      if (!config.enabled || body.classList.contains('drawer-open') || body.classList.contains('filters-open')) {
        topVisibilityLatch = false;
      }

      // At the very top of the page, enabled top-bar must always be visible.
      if (
        config.enabled &&
        currentY <= topSafeOffset &&
        !body.classList.contains('drawer-open') &&
        !body.classList.contains('filters-open')
      ) {
        topVisibilityLatch = true;
        body.classList.remove('a24-topbar-hidden');
        stateLockUntil = 0;
        lastY = currentY;
        ticking = false;
        return;
      }

      if (
        config.enabled &&
        topVisibilityLatch &&
        currentY <= topLatchReleaseOffset &&
        !body.classList.contains('drawer-open') &&
        !body.classList.contains('filters-open')
      ) {
        body.classList.remove('a24-topbar-hidden');
        lastY = currentY;
        ticking = false;
        return;
      }

      if (topVisibilityLatch && currentY > topLatchReleaseOffset) {
        topVisibilityLatch = false;
      }

      if (body.classList.contains('drawer-open')) {
        setTopBarHidden(true);
        lastY = currentY;
        ticking = false;
        return;
      }

      if (body.classList.contains('filters-open')) {
        setTopBarHidden(!config.enabled);
        lastY = currentY;
        ticking = false;
        return;
      }

      if (performance.now() < stateLockUntil) {
        lastY = currentY;
        ticking = false;
        return;
      }

      if (!config.enabled) {
        nextHidden = true;
      } else if (config.scrollBehavior === 'always') {
        nextHidden = false;
      } else if (currentY <= effectiveRevealTopOffset) {
        nextHidden = false;
      } else if (currentY > lastY + scrollThreshold) {
        nextHidden = true;
      } else if (config.revealBehavior === 'scroll_up' && currentY < lastY - scrollThreshold) {
        nextHidden = false;
      } else if (config.revealBehavior === 'top_only') {
        if (mobile) {
          nextHidden = currentY > topSafeOffset;
        } else if (currentY <= effectiveHideTopOffset) {
          nextHidden = false;
        } else if (currentY >= effectiveHideTopOffset) {
          nextHidden = true;
        }
      }

      if (setTopBarHidden(nextHidden)) {
        lastY = currentScrollY();
      } else {
        lastY = currentY;
      }
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });

    var onMediaChange = null;

    if (mobileMediaQuery && typeof mobileMediaQuery.addEventListener === 'function') {
      onMediaChange = function () {
        body.classList.remove('a24-topbar-hidden');
        lastY = currentScrollY();
        requestUpdate();
      };
      mobileMediaQuery.addEventListener('change', onMediaChange);
    }

    scrollState = {
      onScroll: requestUpdate,
      onMediaChange: onMediaChange
    };

    update();
  }

  function initTopBarFeatures() {
    initTopBarInteractionPause();
    initTopBarScrollBehavior();
  }

  initTopBarFeatures();

  document.addEventListener('shopify:section:load', initTopBarFeatures);
  document.addEventListener('shopify:section:reorder', initTopBarFeatures);
  document.addEventListener('shopify:block:select', initTopBarFeatures);
}());
